import React, { useState } from "react";
import WeatherInfo from "./WeatherInfo";
import axios from "axios";
import "./Weather.css";
import WeatherForecast from "./WeatherForecast";
import { ThreeDots } from "react-loader-spinner";

export default function Weather(props) {
  const [city, setCity] = useState(props.defaultCity);
  const [weatherData, setWeatherData] = useState({ ready: false });

  function handleResponse(response) {
    setTimeout(() => {
      setWeatherData({
        ready: true,
        city: response.data.city,
        temperature: response.data.temperature.current,
        date: new Date(response.data.time * 1000),
        feelsLike: response.data.temperature.feels_like,
        description: response.data.condition.description,
        icon: response.data.condition.icon,
        humidity: response.data.temperature.humidity,
        wind: response.data.wind.speed,
        coordinates: response.data.coordinates,
      });
    }, 1500);
  }
  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  function search() {
    const apiKey = "23ab4btd750623bd6a0096bbc3of4f4f";
    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=imperial`;
    axios.get(apiUrl).then(handleResponse);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col">
              <input
                type="search"
                placeholder="Enter a city..."
                className="form-control"
                autoFocus="on"
                onChange={handleCityChange}
              />
            </div>
            <div className="col-auto">
              <input type="submit" value="Search" className="btn w-100" />
            </div>
          </div>
        </form>
        <WeatherInfo data={weatherData} />
        <WeatherForecast coordinates={weatherData.coordinates} />
      </div>
    );
  } else {
    search();
    return (
      <div
        className="Weather d-flex justify-content-center align-items-center"
        style={{ minHeight: "200px" }}
      >
        <ThreeDots
          height="80"
          width="80"
          color="#4db6ac"
          ariaLabel="loading"
          visible={true}
        />
      </div>
    );
  }
}
